import React from 'react'
import BookedList from '../components/BookingHistory/BookedList'
import UnauthorizedBookingModal from '../components/common/UnauthorizedBookingModal'

const BookingHistory = () => {
    return (
        <section class="bookingListMain">
        {/* Raised when an air/ocean booking-detail page bounced back here
            because single_booking_data refused the queryId (404). */}
        <UnauthorizedBookingModal />
        <div className="flex gap-5 w-full flex-col">
            <div className="sm:p-3 p-5 w-full rounded-2xl shadow-cardsection bg-white">
                <BookedList/>
            </div>
        </div>
        </section>
    )
}
export default BookingHistory
